import React, { useState } from 'react'
import { ChevronUp, ChevronDown, Minus, X } from 'lucide-react'
import ProgressBar from '../../../components/ProgressBar'
import ImageModal from '../../ImageModal'

interface Item {
  key: number
  id: number
  name: string
  picture: string
  description: string
  points: string
  redeem: boolean
  showIconBorder?: boolean
  index: number
  length: number
  onRedeem?: () => void,
  selected?: number,
  onSelect?: any,
}

const Item: React.FC<Item> = ({
  key,
  id,
  name,
  description,
  points,
  redeem,
  index,
  length,
  picture,
  showIconBorder = true,
  onRedeem,
  selected,
  onSelect,
}) => {
  const [showModal, setShowModal] = useState(false)
  return (
    <div
      key={id}
      className={`rounded-2xl p-4 mb-4 last:mb-0 relative ${selected === id ? 'bg-primary-blue-90' : ''}`}>
      <div className='flex flex-row md:flex-row items-start md:items-center'>
        <div className='relative'>
          <div
            className={`w-14 h-14 rounded-full flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity`}
            onClick={() => setShowModal(true)}>
            <img src={picture != '' ? picture : "/icons/reward1.svg"} alt={name} className='w-12 h-12' />
          </div>
          {showIconBorder && index !== length - 1 && (
            <div className='absolute top-14 left-1/2 w-0.5 h-[300%] md:h-[150%] bg-primary-blue-90 -translate-x-1/2'></div>
          )}
        </div>
        <div className='flex-grow ml-4 md:ml-4'>
          <div className='flex justify-between mb-2'>
            <h3 className='text-white text-lg font-semibold text-left'>
              {name}
            </h3>
            <button className='text-[#4E5D66] text-sm' onClick={onRedeem}>
              Redeem
            </button>
          </div>
          <p className='text-gray-light text-sm text-left'>{points}</p>
          <p className='text-gray-light text-sm mt-2 text-left'>{description}</p>
        </div>
      </div>
      <ImageModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        imageSrc={picture}
        imageAlt={name}
        fallbackSrc="/icons/reward1.svg"
      />
    </div>
  )
}

export default Item
